import { render, staticRenderFns } from "./Top10HorizontalTitleListGraphql.vue?vue&type=template&id=1ded9e6c&scoped=true"
import script from "./Top10HorizontalTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
export * from "./Top10HorizontalTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Top10HorizontalTitleListGraphql.vue?vue&type=style&index=0&id=1ded9e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded9e6c",
  null
  
)

export default component.exports